// This file uses JSX syntax for Vue components
import { h } from 'vue';
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons-vue';
import { Button } from 'ant-design-vue';
import { RouterLink } from 'vue-router';

export function getTargetFlags(data, profile, filters, checkPermission, handleDeleteTarget) {
  const isEpi = profile.jenis_perusahaan != 'anak';
  const isEditable = data.editable;
  const isPengurang = data.jenis_variable_kpi_id == 3;
  const isREL = data.status == 'REL';
  const isCreateTarget = checkPermission('create kpi korporat') && isEditable && isEpi && !isPengurang;
  const isUpdateTarget = checkPermission('update kpi korporat') && isEditable && isEpi && !isPengurang;
  const isDeleteTarget = checkPermission('delete kpi korporat') && isEditable && isEpi && !isPengurang && !isREL;

  const deleteButton = (id, name, target_month, target_year) => {
    return h(Button, {
      shape: 'circle',
      icon: h(DeleteOutlined),
      size: 'small',
      style: 'background-color: transparent; border: none; color: #555',
      onClick: () => handleDeleteTarget(id, name, target_month, target_year),
    });
  };

  const updateButton = target_id => {
    return h(
      RouterLink,
      {
        to: `/nko-kontrak-edit-target/${target_id}`,
      },
      {
        default: () =>
          h(Button, {
            shape: 'circle',
            icon: h(EditOutlined),
            size: 'small',
            style: 'background-color: transparent; border: none; color: #555',
          }),
      },
    );
  };

  const createButton = (id, month, year) => {
    return h(
      RouterLink,
      {
        to: `/nko-kontrak-add-target/${id}/${month}/${year}`,
      },
      {
        default: () =>
          h(Button, {
            shape: 'circle',
            icon: h(PlusOutlined),
            size: 'small',
            style: 'background-color: transparent; border: none; color: #555',
          }),
      },
    );
  };

  const createTarget = isCreateTarget ? createButton : () => null;
  const updateTarget = isUpdateTarget ? updateButton : () => null;
  const delTarget = isDeleteTarget ? deleteButton : () => null;

  return {
    createTarget,
    updateTarget,
    delTarget,
  };
}
